export default __webpack_public_path__ + "static/media/client6.12169f1d.png";